import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import SignUp from "./pages/SignUp";
import ContactUsPage from "./pages/ContactUsPage";
import Services from "./pages/Services";
import Blog from "./pages/Blog/Blog";
import BlogPost from "./pages/Blog/BlogPost";
import About from "./pages/About";
import PrivateRoute from "./components/PrivateRoute";
import BookSession from "./components/BookSession";
import ProfilePage from "./pages/ProfilePage";
import Booking from "./pages/Booking";
import AdminDash from "./pages/AdminDash";

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
             
            </PrivateRoute>
          }
        />
        <Route path="/contactus" element={<ContactUsPage />} />
        <Route path="/services" element={<Services />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogPost />} />
        <Route path="/about" element={<About />} />
        <Route path="/booksession" element={<BookSession />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/booking" element={<Booking />} /> 
         <Route path="/admindashboard" element={<AdminDash/>} /> 
      </Routes>
    </div>
  );
}

export default App;
